// extracted by mini-css-extract-plugin
module.exports = {"customTip":"TipsApplier_customTip__2V1yp"};